// Copyright (c) Docugami, Inc. All rights reserved.

import { CanvasHelperStatics } from "components/doc_hosting/doc_hosts/web/CanvasHelperStatics";
import { ComponentId } from "sdv/engine/Component";
import { IDrawCommand, IRenderer, IRendererInput, Queries } from "sdv/engine/Engine";
import { ChunkRenderComponent } from "sdv/components/ChunkRenderComponent";
import { chunkSelectedBorderColor } from "components/shell/presentation/AppStyles";

/**
 * Renders outlines for standard chunks
 */
export class ChunkOutlineRenderer implements IRenderer {
    get renderEnabled(): boolean { return true; }

    queries: Queries = {
        outlineChunks: { types: [ComponentId.ChunkRender, ComponentId.Renderable] }
    }

    render(engine: IRendererInput): IDrawCommand[] {
        const commands: IDrawCommand[] = []

        for (const chunk of this.queries.outlineChunks.query!.entities) {
            if (chunk.hasComponent(ComponentId.Selected) || chunk.hasComponent(ComponentId.Resize)) {
                const renderInfo = chunk.getComponent<ChunkRenderComponent>(ComponentId.ChunkRender)!;
                commands.push(context => drawOutline(context, renderInfo, chunkSelectedBorderColor));
            }
        }

        return commands;
    }
}

function drawOutline(context: CanvasRenderingContext2D, chunk: ChunkRenderComponent, outlineColor: string): void {
    const thickness = 4;
    for (const box of chunk.renderBoxes) {
        CanvasHelperStatics.strokeRectangle(
            context,
            box.box,
            outlineColor,
            thickness,
            false
        );
    }

    for (const box of chunk.renderBoxes) {
        context.clearRect(box.box.left, box.box.top, box.box.right - box.box.left, box.box.bottom - box.box.top);
    }

    if (chunk.containerBoxes.length > 1) {
        for (let i = 0; i < chunk.containerBoxes.length; ++i) {
            const box = chunk.containerBoxes[i];
            if (i !== 0) {
                context.clearRect(box.left - thickness, box.top - thickness, box.right - box.left + thickness * 2, thickness);
            }

            if (i !== chunk.containerBoxes.length - 1) {
                context.clearRect(box.left - thickness, box.bottom, box.right - box.left + thickness * 2, thickness);
            }
        }
    }
}
